import { Button, Layout } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import useMedia from "use-media";
import { Logo } from "../logo.jsx";
import { OnlineIndicator } from "../onlineIndicator.jsx";
import { MobileMenu } from "./MobileMenu.jsx";
import { ProfileMenu } from "./ProfileMenu.jsx";
import { Link } from "react-router-dom";
import DTOclubSelector from "~/components/club/DTOclubSelector.jsx";
import { LogoutOutlined } from "@ant-design/icons";
import { ConfirmLogout } from "./ConfirmLogout.jsx";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";

export function AppHeader({ triggerShowCheckModal, isDTOview, isAssociationview }) {
  const persist = useSelector((state) => state.persist);
  const isNarrow = useMedia({ maxWidth: "1000px" }, true);
  const showMobileMenu = isNarrow;
  const [confirmLogout, setConfirmLogout] = useState(false);
  const history = useHistory();

  return (
    <Layout.Header
      style={{
        position: "fixed",
        top: 0,
        zIndex: 500,
        width: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      {!isDTOview && showMobileMenu && (
        <MobileMenu
          showCheckDataButton={persist.profile.check_required}
          triggerShowCheckModal={triggerShowCheckModal}
          profile={persist.profile}
          club={persist.club}
        />
      )}

      {!isNarrow && persist?.club?.is_association !== "" && <DTOclubSelector />}

      <Link className="row" to={"/"}>
        {persist.club && persist.club.logo && <Logo url={persist.club.logo} />}

        {persist.club && (
          <p className="white" style={{ fontWeight: 700, fontSize: 15 }}>
            {isNarrow ? persist.club.name : persist.club.full_name}
          </p>
        )}
      </Link>

      <div style={{ flexGrow: 1 }} />

      <OnlineIndicator />

      {!isDTOview && (
        <>
          {persist.profile.vliegt ||
          persist.profile.group_keys?.includes("niet_vliegend") ? (
            <ProfileMenu persist={persist} isAssociationview={isAssociationview} />
          ) : (
            <Button
              shape={"circle"}
              icon={<LogoutOutlined />}
              onClick={() => {
                if (persist.profile.wijzig_start) {
                  setConfirmLogout(true);
                } else {
                  history && history.push("/login");
                }
              }}
            />
          )}
        </>
      )}

      <ConfirmLogout
        show={confirmLogout}
        closeModal={() => setConfirmLogout(false)}
        history={history}
      />
    </Layout.Header>
  );
}
